import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import "./partnerships_carousel.css";

const PartnershipsCarousel = ({ partners, sliderConfig }) => {
    const [sliderRef, instanceRef] = useKeenSlider({
        ...sliderConfig,
        loop: true,
    });

    const loopPartners = partners?.length ? [...partners, ...partners, ...partners] : [];

    if (!partners?.length) return null;

    return (
        <div className="partnerships_carousel_wrap">
            <div className="partnerships_carousel_container">
                <button
                    type="button"
                    className="partnerships_carousel_arrow partnerships_carousel_arrow_prev"
                    onClick={() => instanceRef?.current?.prev()}
                    aria-label="Slide anterior"
                >
                    <FaChevronLeft />
                </button>
                <div className="partnerships_carousel keen-slider" ref={sliderRef}>
                    {loopPartners.map((partner, index) => (
                        <div key={`partner-${index}`} className="keen-slider__slide partnerships_slide">
                            <div className="partnerships_slide_inner">
                                <img src={partner.image} alt="Parceiro" />
                            </div>
                        </div>
                    ))}
                </div>
                <button
                    type="button"
                    className="partnerships_carousel_arrow partnerships_carousel_arrow_next"
                    onClick={() => instanceRef?.current?.next()}
                    aria-label="Próximo slide"
                >
                    <FaChevronRight />
                </button>
            </div>
        </div>
    );
};

export default PartnershipsCarousel;
